import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

interface IpApiResponse {
  city: string;
  region: string;
  country_name: string;
}

@Injectable({ providedIn: 'root' })
export class GeolocationService {
  private cached: string | null = null;
  private http: HttpClient;

  constructor(backend: HttpBackend) {
    // HttpBackend bypasses all interceptors so a CORS/network failure
    // on ipapi.co never triggers the app-wide "Connection Error" toast.
    this.http = new HttpClient(backend);
  }

  getCityFromIp(): Observable<string> {
    if (this.cached !== null) {
      return of(this.cached);
    }
    return this.http.get<IpApiResponse>('https://ipapi.co/json/').pipe(
      map(res => {
        const city = res.city && res.region
          ? `${res.city}, ${res.region}, ${res.country_name}`
          : res.city || '';
        this.cached = city;
        return city;
      }),
      catchError(() => {
        this.cached = '';
        return of('');
      })
    );
  }
}
